import "./ProjectRoadmapPage.css";

import { EmptyRoadmapIcon, RoundedPlusSignIcon } from "../../../../assets";
import { EditDatesPanel } from "../../../../templates";
import { WorkflowTaskPanel } from "../../../../templates/WorkflowTaskPanel";
import { Button, Column, GanttChart, Row } from "../../../../widget";
import { SelectProjectsModal } from "./components";
import { useProjectRoadmapPage } from "./useProjectRoadmapPage";

export const ProjectRoadmapPage = (): JSX.Element => {
  const {
    errors,
    data,
    ganttRows,
    theme,
    onRowClick,
    onPhaseClick,
    onMilestoneClick,
    onKeyDateClick,
    projectsMultiSelectData,
    editDatesPanelData,
    editDatesPanelPhase,
    showEditDatesPanel,
    setEditDatesPanelData,
    closeEditDatesPanel,
    selectedTask,
    taskPanelWorkflow,
    showTaskPanel,
    taskPanelRefresh,
    handleTaskPanelRefresh,
    closeTaskPanel,
    roadmapProjectUuids,
    setRoadmapProjectUuids,
    showAddProjectsModal,
    setShowAddProjectsModal,
    closeSelectProjectsModal,
    onSaveProjectsSelectData,
    isLoading,
    fetchSelectData,
  } = useProjectRoadmapPage();

  return (
    <div className="ProjectRoadmapPageContainer">
      <Row spacingV="ml">
        <Column span={12}>
          <h2>Project roadmap</h2>
        </Column>
      </Row>
      <Row>
        <Column span={12}>
          <p className="body1">
            Only projects with an assigned workflow will appear on the roadmap. To assign workflows, visit the workflows
            section. You can edit dates directly by clicking on the timeline.
          </p>
        </Column>
      </Row>
      {(data !== undefined && data.length > 0) || isLoading ? (
        <div className="PopulatedRoadmap">
          <GanttChart
            variant="project-roadmap"
            mode="phase"
            rows={ganttRows}
            isLoading={isLoading}
            theme={theme}
            onRowClick={onRowClick}
            onPhaseClick={onPhaseClick}
            onMilestoneClick={onMilestoneClick}
            onKeyDateClick={onKeyDateClick}
            onEditProjectsClick={() => setShowAddProjectsModal(true)}
            onAddObjectsClick={() => setShowAddProjectsModal(true)}
          />
        </div>
      ) : (
        <div className="EmptyRoadmap">
          <EmptyRoadmapIcon />
          <h1>Your roadmap is almost ready</h1>
          <p className="body1">Add projects to populate your roadmap.</p>
          <Button
            className="AddProjectsButton"
            text="Add projects"
            icon={<RoundedPlusSignIcon />}
            onClick={() => setShowAddProjectsModal(true)}
          />
        </div>
      )}
      {editDatesPanelData && (
        <EditDatesPanel
          data={editDatesPanelData}
          setData={setEditDatesPanelData}
          show={showEditDatesPanel}
          onClose={closeEditDatesPanel}
          initialPhase={editDatesPanelPhase}
        />
      )}
      {/* A milestone diamond opens its task here; the phase bars and key dates open the dates panel. */}
      <WorkflowTaskPanel
        task={selectedTask}
        currentStepUuid={selectedTask?.step?.uuid}
        workflow={taskPanelWorkflow}
        show={showTaskPanel}
        refresh={taskPanelRefresh}
        handleRefresh={handleTaskPanelRefresh}
        onClose={closeTaskPanel}
      />
      <SelectProjectsModal
        errors={errors}
        roadmapProjectUuids={roadmapProjectUuids}
        setRoadmapProjectUuids={setRoadmapProjectUuids}
        projectsMultiSelectData={projectsMultiSelectData}
        onSaveProjectsSelectData={onSaveProjectsSelectData}
        show={showAddProjectsModal}
        closePanel={closeSelectProjectsModal}
        fetchSelectData={fetchSelectData}
      />
    </div>
  );
};
